import {defineStore} from 'pinia';
import {computed, ref, watch} from 'vue';
import { MarkType } from '@/core/interface/api-interface';
import LocalStorageDecorator from '@/store/storage/local-storage-decorator';
import { useAnalytics } from '@/composables/useAnalytics';

interface MarkImage {
    url: string;
    ref: string;
}

export interface TrademarkStore {
    trademarkWord: string|null;
    trademarkImage: MarkImage|null;
    uploadedAsWordImage: boolean;
}

export const useTrademarkStore = defineStore('TrademarkStore', () => {
    const trademarkWord = ref<string|null>(null)
    const trademarkImage = ref<MarkImage|null>(null)
    const uploadedAsWordImage = ref(false);
    const analytics = useAnalytics();

    function addTrademarkWord(word: string | null) {
        trademarkWord.value = word;
        trademarkImage.value = null;
        uploadedAsWordImage.value = false;
    }

    function addTrademarkImage(image: MarkImage | null) {
        trademarkImage.value = image;
        trademarkWord.value = null;
    }

    function resetData() {
        trademarkWord.value = null;
        trademarkImage.value = null;
    }

    const trademarkType = computed(() => {
        if (trademarkWord.value) {
            return MarkType.WORDS;
        } else if (trademarkImage.value) {
            if (uploadedAsWordImage.value) {
                return MarkType.WORDS_IMAGE;
            } else {
                return MarkType.IMAGE;
            }
        }

        return null;
    });

    const trademarkImageUrl = computed(() => {
        if (trademarkImage.value) {
            return trademarkImage.value.url;
        }

        return null;
    })

    const isTrademarkStepValid = computed(() => {
        return trademarkWord.value != null || trademarkImage.value != null;
    })

    function importData(data: TrademarkStore) {
        trademarkWord.value = data.trademarkWord;
        trademarkImage.value = data.trademarkImage;
        uploadedAsWordImage.value = data.uploadedAsWordImage;
    }

    watch(isTrademarkStepValid, (valid) => {
        if (valid) {
            analytics.sendEvent('card_completed_trademark');
        }
    });


    return {
        trademarkImage, 
        trademarkImageUrl,
        uploadedAsWordImage,
        trademarkWord, 
        trademarkType, 
        isTrademarkStepValid, 
        addTrademarkWord, 
        addTrademarkImage,
        resetData,
        importData
    }
},{
    persist: {
        storage: LocalStorageDecorator
    },
})
